/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import { useCallback } from 'react';
import { Bar, Icon, Modals, Title } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';
import VideoIframe from '@/components/videoPlayer/VideoIframe';

interface IUseVideoDialog {
    title: string;
    src: string;
}

const useVideoDialog = ({ title, src }: IUseVideoDialog) => {
    const handleIntroDialog = useCallback(() => {
        const { close } = Modals.showDialog({
            style: { width: '700px', height: '490px' },
            className: 'ui5-dialog ui5-dialog-header',
            initialFocus: 'decline',
            header: (
                <Bar
                    className="bar-header"
                    startContent={<Title level="H5">{title}</Title>}
                    endContent={<Icon design="Information" name="decline" style={{ cursor: 'pointer' }} onClick={() => close()} />}
                />
            ),
            children: (
                <VideoIframe
                    style={{
                        padding: ThemingParameters.sapContent_Margin_Small,
                        borderRadius: 'none',
                    }}
                    src={src}
                />
            ),
        });
    }, [title, src]);

    return handleIntroDialog;
};

export default useVideoDialog;
